import React from 'react';
import {createStyles, makeStyles, TableCell, Theme} from '@material-ui/core';
import clsx from 'clsx';

import SortingIcon from './SortingIcon';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    color: palette.table.header.color,
    '&:hover': {
      color: palette.table.header.hover,
    },
  },
  sortable: {
    cursor: 'pointer',
  },
  hidden: {
    display: 'none',
  },
}), { name: 'TableHeader' });


type Props = React.ComponentProps<typeof TableCell> & {
  toggleSort?: React.MouseEventHandler;
};

const TableHeader = ({
  toggleSort,
  children,
  className = '',
  ...props
}: Props) => {
  const classes = useStyles();
  const classList = className.split(' ');

  const isSortable = classList.includes('-cursor-pointer');
  const isHidden = classList.includes('-hidden');

  return (
    <TableCell
      onClick={toggleSort}
      className={clsx(className, {
        [classes.sortable]: isSortable,
        [classes.hidden]: isHidden,
      })}
      {...props}
    >
      <div className={classes.container}>
        {children}
        {isSortable && (
          <SortingIcon
            asc={classList.includes('-sort-asc')}
            desc={classList.includes('-sort-desc')}
          />
        )}
      </div>
    </TableCell>
  );
};

export default TableHeader;
